import { Dialog } from '@base-ui/react/dialog';

import { useDialog } from '../contexts/dialog-context';

export function SharedDialog() {
  const { open, setOpen, content, closeDialog } = useDialog();

  return (
    <Dialog.Root
      open={open}
      onOpenChange={(newOpen: boolean) => {
        if (!newOpen) {
          closeDialog(); // needed for close events that are not triggered by Dialog.Close
        } else {
          setOpen(newOpen);
        }
      }}
    >
      <Dialog.Portal
        container={document.getElementById('services-portal-root')?.shadowRoot}
      >
        <Dialog.Backdrop className="dialog-backdrop" />
        <Dialog.Popup className="dialog-popup" id="base-modal">
          <>
            <div className="dialog-close-action">
              <Dialog.Close className="button button-icon">x</Dialog.Close>
            </div>
            {content}
          </>
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
